// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/item_attributes/lista
 *
 * Returns the full list of active item attributes. Legacy `dados` shape
 * is a list, so getDados() returns the array directly.
 */
import type { Item_attributes_AttributeRow } from './Item_attributes_AttributeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Item_attributes_ListaResponseDados = Item_attributes_AttributeRow[];

export type Item_attributes_ListaResponse = ApiResponse<Item_attributes_ListaResponseDados>;

registerResponseContract('Item_attributes_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_item_attribute_id:         { type: 'number',  required: true },
      so_item_attribute_name:       { type: 'string',  required: true },
      so_item_attribute_type:       { type: 'string',  required: true },
      so_item_attribute_active:     { type: 'number',  required: true },
      so_item_attribute_created_at: { type: 'string',  required: true },
    },
  },
})
